// Vue
import { createApp } from 'vue';

// -- TO REMOVE
import base from "@/toremove/components/octolo/base";
import basev2 from "@/componentsv2/Base/";
import 'bootstrap';
import "@/assets/bootstrap.scss";
import VueApexCharts from "vue3-apexcharts";
import mitt from 'mitt';
// TO REMOVE

import octolo from "@/octolo.js";
import components from "@/components.js";
//import translate from '@/octolo/user/libs/translate.js';
//import config from '@/octolo/user/libs/config.js';

// Libraries
import modal_lib from "@/libraries/modal/index.js"; // Modal (<octolo-modalv2> component)
import "@/libraries/modal/style.scss";
import contextualmenu_lib from "@/libraries/contextualmenu/index.js"; // Contextual Menu (ctxOpen(menu) generate a contextual menu without component)
import "@/libraries/contextualmenu/style.scss";
import dynamictable_lib from "@/libraries/dynamictable/index.js"; // Dynamic table (<dynamic-table> component table)
import "@/libraries/dynamictable/style.scss";
import dynamictable2_lib from "@/libraries/dynamictable2/index.js"; // Dynamic table (<dynamic-table> component table)
import "@/libraries/dynamictable2/style.scss";
import pagination_lib from "@/libraries/pagination/index.js"; // Pagination system
import "@/libraries/pagination/style.scss";
// Components
import exports_comp from "@/libraries/exports/index.vue"; // Export system
import "@/libraries/exports/style.scss";
import froala_comp from "@/libraries/froala/index.vue"; // Froala
import dataroom_comp from "@/libraries/dataroom/index.vue"; // Dataroom
import "@/libraries/dataroom/style.scss";
import votesystem_comp from "@/libraries/votesystem/index.vue"; // Vote System
import "@/libraries/votesystem/style.scss";
import dynamicform from "@/libraries/dynamicform/index.vue"; // Dynamic form
// Directives
import vLoopEnd from '@/libraries/loopend.js'; // Loop End (v-loop-end signal end of loop)
import vClickOutside from '@/libraries/clickoutside.js'; // Click outside (v-click-outside signal click oustide element)
import vTooltip from './libraries/tooltip';
import http from "@/api.js";

// Externals
import 'vite/modulepreload-polyfill';
import * as Sentry from "@sentry/vue";
import { extraErrorDataIntegration } from "@sentry/integrations";
import { createVfm } from 'vue-final-modal';
import 'vue-final-modal/style.css';
import { library } from "@fortawesome/fontawesome-svg-core"; // FontAwesome
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fas, far, fab);

// --- Day.js ---
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";
// Needed locales
import "dayjs/locale/fr";
import {
    gettext,
    interpolate,
    ngettext,
    pgettext,
    npgettext,

} from "@/libraries/i18n";

// Day.js plugins
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

const SUPPORTED_LOCALES = ["fr", "en"];
// Determine the locale from the cookie or browser settings
const raw = getCookie('octolo_language')
          || window.navigator.userLanguage
          || window.navigator.language;   // ex: "de-DE" ou "en-US"
// Keep only the part before the dash and convert to lowercase
const localeBase = raw.split(/[-_]/)[0].toLowerCase(); // → "de", "en", etc.
// Fallback to "fr" if not supported
const locale = SUPPORTED_LOCALES.includes(localeBase) ? localeBase : "fr";


// Set the locale for Day.js
dayjs.locale(locale);

function mountApp(vueAPP, args, dontgetold=false) {
    const app = createApp(vueAPP);
    app.appName = 'octolo-vue3';
    app.config.globalProperties.$locale = locale;
    app.config.globalProperties.$dayjs = dayjs;
    app.config.globalProperties.$group_named_id = window.OCT_GROUP_NAMED_ID ?? null;
    app.config.globalProperties.$is_staff = window.OCT_IS_STAFF ?? false;
    app.config.globalProperties.$is_admin = window.OCT_IS_ADMIN ?? false;
    app.config.globalProperties.$is_manager = window.OCT_IS_MANAGER ?? false;
    app.config.globalProperties.$beta_tester = window.OCT_BETA_TESTER ?? false;
    app.config.globalProperties.$authorization_level = window.OCT_AUTHORIZATION_LEVEL ?? null;
    app.config.globalProperties.$roles = window.OCT_ROLES ?? [];

    // -- TO REMOVE
    if(!dontgetold){
        app.mixin(base);
        app.mixin(basev2);
        app.use(VueApexCharts);
        const emitter = mitt();
        app.config.globalProperties.emitter = emitter;
    }

    app.config.globalProperties.$api = http;
    app.mixin(octolo);
    app.mixin(components);
    //app.mixin(config);
    //app.mixin(translate);

    // Libraries
    app.mixin(modal_lib);
    app.mixin(contextualmenu_lib);
    app.mixin(dynamictable_lib);
    app.mixin(dynamictable2_lib);
    app.mixin(pagination_lib);
    // components
    app.component("export-list-global-detail", exports_comp);
    app.component('octolo-dataroom', dataroom_comp);
    app.component('octolo-froala', froala_comp);
    app.component('octolo-votesystem', votesystem_comp);
    app.component('dynamic-form', dynamicform);
    // Directives
    app.directive('loopEnd', vLoopEnd);
    app.directive('clickOutside', vClickOutside);
    app.directive('tooltip', vTooltip);

    // Attach gettext to the global Vue instance properties
    app.config.globalProperties.gettext = gettext;
    app.config.globalProperties.interpolate = interpolate;
    app.config.globalProperties.ngettext = ngettext;
    app.config.globalProperties.pgettext = pgettext;
    app.config.globalProperties.npgettext = npgettext;

    // Externals
    app.use(createVfm())
    app.component('fa', FontAwesomeIcon);

    // Add from args
    if('mixin' in args) args.mixin.forEach(e => { app.mixin(e); });
    if('component' in args) args.component.forEach(e => { app.component(e[0], e[1]); });
    if('use' in args) args.use.forEach(e => { app.use(e); });
    if('directive' in args) args.directive.forEach(e => { app.directive(e[0], e[1]); });
    if('store' in args) app.use(args.store);
    if('router' in args) app.use(args.router);

    return app;
}

function setupSentry(app, router) {
    var environment = 'local';
    if (import.meta.env.PROD) {
        const hostname = new URL(import.meta.url).hostname;
        if (hostname.startsWith('octolo.tech'))
            environment = 'prod'
        else {
            const hostnameParts = hostname.split('.');
            if (hostnameParts.length > 2)
                environment = hostnameParts[0];
        }
    }

    Sentry.init({
        app,
        dsn: "https://1c3eb6e7c54d46f5ade00e5cdcc664d3@sentry.octolo.tech/3",
        integrations: [
            Sentry.browserTracingIntegration({ ...(router ? router : {})}),
            extraErrorDataIntegration(),
        ],
        trackComponents: true,
        tracesSampleRate: 1.0, // We recommend adjusting this value in production
        tracePropagationTargets: ["localhost", "/^\\/|octolo\\.tech/", /^\//],
        replaysSessionSampleRate: 1.0, // Capture Replay for 10% of all sessions, plus for 100% of sessions with an error
        environment: environment,
         beforeSend(event, hint) {
            const error = hint.originalException;
            const ignore_status = []; // List of HTTP status codes to ignore [404, 403, 400, 500]
            const ignore_messages = [
                "canceled",
                "AbortError",
                "Operation canceled"
            ]; // List of error names to ignore

            // Exemple : ignorer les erreurs 404
            if (error && error.response && ignore_status.includes(error.response.status)) {
                return null;
            }

            // Ignore specific error names
            if (error && ignore_messages.some(e => error.name === e)) {
                return null;
            }

            // Ignore specific error messages
            if (error && ignore_messages.some(e => error.message.includes(e))) {
                return null;
            }

            return event;
        },
    });

    return Sentry;
}

export { mountApp, setupSentry };
